import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";

// ---------------------------------------------------------------------------
// Session & RTC token async thunks
// ---------------------------------------------------------------------------

export const fetchTeamSession = createAsyncThunk(
    "teamFocusSession/fetchSession",
    async (teamId: string, { rejectWithValue }) => {
        try {
            const data = await api.teamMode.getSession(teamId);
            return { teamId, data };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch team session",
            );
        }
    },
);

export const fetchRtcToken = createAsyncThunk(
    "teamFocusSession/fetchRtcToken",
    async (teamId: string, { rejectWithValue }) => {
        try {
            const data = await api.teamMode.getRtcToken(teamId);
            return { teamId, rtcToken: data.rtcToken };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch RTC token",
            );
        }
    },
);

export const updateTeamTimer = createAsyncThunk(
    "teamFocusSession/updateTimer",
    async (
        {
            roomId,
            action,
            duration,
        }: {
            roomId: string;
            action: "start" | "pause" | "end";
            duration?: number;
        },
        { rejectWithValue }
    ) => {
        try {
            const data = await api.teamMode.updateTimer(roomId, { action, });
            return { roomId, action, data };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to update timer"
            );
        }
    }
);

export const endTeamSession = createAsyncThunk(
    "teamFocusSession/endSession",
    async (roomId: string, { rejectWithValue }) => {
        try {
            const data = await api.teamMode.endSession(roomId);
            return { roomId, data };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to end team session"
            );
        }
    }
);

export const leaveTeamSession = createAsyncThunk(
    "teamFocusSession/leaveSession",
    async (roomId: string, { rejectWithValue }) => {
        try {
            const data = await api.teamMode.leaveSession(roomId);
            return { roomId, data };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to leave team session"
            );
        }
    }
);

export const participantJoinSession = createAsyncThunk(
    "teamFocusSession/participantJoin",
    async (roomId: string, { rejectWithValue }) => {
        try {
            const data = await api.teamMode.participantJoin(roomId);
            return { roomId, data };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to join session"
            );
        }
    }
);

export const participantLeaveSession = createAsyncThunk(
    "teamFocusSession/participantLeave",
    async (roomId: string, { rejectWithValue }) => {
        try {
            const data = await api.teamMode.participantLeave(roomId);
            return { roomId, data };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to leave session"
            );
        }
    }
);
